module.exports = __webpack_public_path__ + "static/media/DispenserlessTape.fd328dc3.jpg";